import styled from 'styled-components';

export const Container = styled.div`
	margin-top: 15px;
`;

export const Row = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 5px;
	margin-top: 5px;
`;
